// src/components/sensors/LevelSensorView.js
import React from 'react';

const LevelSensorView = ({ sensorStats }) => {
  if (!sensorStats) {
    return (
      <div className="text-center p-3">
        <i className="bi bi-question-circle text-muted me-2"></i>
        Nessun dato disponibile
      </div>
    );
  }
  
  return (
    <div className="row g-2 mb-3">
      <div className="col-12">
        <div className="bg-light p-2 rounded h-100">
          <div className="d-flex justify-content-between">
            <h4 className="small fw-semibold text-muted mb-0">Livello</h4>
            <span className="badge bg-secondary text-white small">
              {sensorStats.lastUpdateTime ? new Date(sensorStats.lastUpdateTime).toLocaleTimeString('it-IT', {hour: '2-digit', minute:'2-digit'}) : 'N/A'}
            </span>
          </div>
          <div className="fs-1 fw-bold text-primary lh-1 my-1">
            {sensorStats.currentLivello.toFixed(1)} cm
          </div>
          <div className="small text-muted lh-sm">
            <div className="d-flex justify-content-between">
              <span>Min: {sensorStats.livelloMin.toFixed(1)} cm <small>({sensorStats.livelloMinTime})</small></span>
              <span>Max: {sensorStats.livelloMax.toFixed(1)} cm <small>({sensorStats.livelloMaxTime})</small></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LevelSensorView;